import { render, staticRenderFns } from "./-Professionals.vue?vue&type=template&id=6b50cd9f&scoped=true&"
import script from "./-Professionals.vue?vue&type=script&lang=js&"
export * from "./-Professionals.vue?vue&type=script&lang=js&"
import style0 from "./-Professionals.vue?vue&type=style&index=0&id=6b50cd9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50cd9f",
  null
  
)

export default component.exports